import WebView from "@/Layouts/WebView";
import {Head, Link, useForm, usePage} from "@inertiajs/inertia-react";
import React, {Fragment, useEffect} from "react";
import ProductLogo from "@/Components/ProductLogo";
import {FormInput, PhoneOrEmailInput} from "@/Components/Controls";
import i18n from "i18next";
import Button from "@/Components/Button";
import styles from "../../../../sass/webview/components/EditProfile.module.scss";
import notifyNativeApp from "@/Utilities/NotifyNativeApp";

export default function EditProfile() {
    const organization = usePage().props.organization;
    const user = usePage().props.auth.user;
    const notifyOfChanges = usePage().props.notify;

    const {data, setData, put, processing, errors} = useForm({
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone: user.phone
    });

    useEffect(() => {
        if (notifyOfChanges) {
            notifyNativeApp(notifyOfChanges, 5000)
        }
    }, [notifyOfChanges]);


    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        put(route('webview.account.update', organization.uuid));
    };

    return (
        <WebView>
            <Head title={i18n.t("my-profile-slider.edit-my-profile")}/>
            <ProductLogo />
            <div className="">
                <Fragment>
                    <div className="">
                        <form onSubmit={submit}>
                            <div>
                                <div className="row">
                                    <FormInput error={errors["first_name"]} name="first_name" isFocused={true}
                                               autoComplete="first_name" value={data.first_name} onChange={onChange}
                                               label={i18n.t("my-profile-slider.first-name")} className="col-12"
                                               dataQa="my-profile-first-name"/>
                                </div>
                                <div className="row">
                                    <FormInput error={errors["last_name"]} name="last_name" autoComplete="last_name"
                                               value={data.last_name} onChange={onChange}
                                               label={i18n.t("my-profile-slider.last-name")} className="col-12"
                                               dataQa="my-profile-last-name"/>
                                </div>
                                <div className="row">
                                    <FormInput error={errors["email"]} name="email" autoComplete="email"
                                               value={data.email} onChange={onChange}
                                               label={i18n.t("my-profile-slider.email")} className="col-12"
                                               dataQa="my-profile-email"/>
                                </div>
                                <div className="row">
                                    <PhoneOrEmailInput error={errors["phone"]} name="phone" autoComplete="phone"
                                                       value={data.phone} onChange={onChange}
                                                       label={i18n.t("my-profile-slider.phone")} className="col-12"
                                                       dataQa="my-profile-phone"/>
                                </div>
                                <div>
                                    <Button className="w-100 btn btn-primary" processing={processing}>
                                        {processing && <Fragment>
                                            <span className="spinner-border spinner-border-sm" role="status"
                                                  aria-hidden="true"></span>
                                            <span className="visually-hidden">Loading...</span>
                                        </Fragment>}
                                        {!processing && i18n.t("my-profile-slider.save")}
                                    </Button>
                                </div>
                            </div>
                            <div className={styles.deleteAccount}>
                                <Link
                                    href={route('webview.account.destroy', organization.uuid)}
                                    method="delete" as="button"
                                    className="btn btn-link text-center"
                                >
                                    {i18n.t("my-profile-slider.request-account-deletion")}
                                </Link>
                            </div>
                        </form>
                    </div>
                </Fragment>
            </div>
        </WebView>
    )
}
